type ZodIssueLike = {
  code?: string
  path?: Array<string | number>
  received?: unknown
}

type SerializedProductError = {
  raw: unknown
  error: { name?: string; issues?: ZodIssueLike[]; message?: string }
}

function isInvalidTypeEnumIssue(issue: ZodIssueLike): boolean {
  if (issue?.code !== 'invalid_enum_value') return false
  const path = issue.path
  if (!Array.isArray(path) || path.length === 0) return false
  return path[path.length - 1] === 'type'
}

export function extractInvalidEnumTypes(errors: SerializedProductError[]): string[] {
  const types = new Set<string>()
  for (const { raw, error } of errors) {
    const issues = error?.issues ?? []
    if (!issues.some(isInvalidTypeEnumIssue)) continue
    const rawType = (raw as { type?: unknown })?.type
    if (typeof rawType === 'string' && rawType.length > 0) {
      types.add(rawType)
    }
  }
  return Array.from(types).sort()
}

export function parseInvalidEnumTypesFromMessage(message: string | null | undefined): string[] {
  if (!message) return []
  try {
    const parsed: unknown = JSON.parse(message)
    if (!Array.isArray(parsed)) return []
    const types = new Set<string>()
    for (const issue of parsed as ZodIssueLike[]) {
      if (isInvalidTypeEnumIssue(issue) && typeof issue.received === 'string' && issue.received.length > 0) {
        types.add(issue.received)
      }
    }
    return Array.from(types).sort()
  } catch {
    return []
  }
}
